import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { WorkerServiceService } from '../../services/worker-service.service';
import { DomSanitizer } from '@angular/platform-browser';

import { ServerTokenService } from '../../services/server-token.service';
import { WorkflowService } from '../../services/workflow.service';
import { PdfData } from 'shared-types';

@Component({
  selector: 'ngx-export-pdf',
  templateUrl: './export-pdf.component.html',
  styleUrls: ['./export-pdf.component.scss']
})
export class ExportPdfComponent implements OnInit {
  @ViewChild('chart_line_lives', { static: false }) chartLives: ElementRef;
  @ViewChild('chart_line_lives2', { static: false }) chartLives2: ElementRef;
  @ViewChild('toPdf', { static: false }) toPdf: ElementRef;
  @ViewChild('download', { static: false }) download: ElementRef;

  
  @Input() pdfData: PdfData;
  @Input() generalInfo;
  @Input() dirName;
  leData

  leTablesData =  {lives: undefined, dies: undefined};//['lives'] = prediction.livesTable
  //prediction.projectedDeathTable projectedDeathTable livesTable


  htmlDisclaimer = disclaimer;
  livesArray;
  // footerData
  test
  chartOptions
  fileName
  fileUrl
  keys = ['Name', 'Gender', 'Age', 'DOB', 'Smoke', 'Medical Records Start Date', 'Medical Records End Date',
    'Adress', 'State', 'SSN', 'Hight', 'BMI', 'Smoker', 'Life Expectancy Mean', 'Life Expectancy Median', 'Main Contributing Factors'];
  pdfIsReady: boolean = false
  URL: string

  predictionData: any[]
  medicalHistoryInfo: any[]
  impairments: any[]
  medication: any[]
  labs: any[]
  behavioral: any[]
  footerData: any[]

  
  constructor(protected dataService: WorkerServiceService, private server: ServerTokenService, private sanitizer: DomSanitizer,
    protected workflow: WorkflowService) {
      console.log('ngx export pdf constuctor ', history.state)
  }
  ngOnInit() {
    console.log(this.workflow.variables.processData)
    console.log('input ledata', this.pdfData, this.generalInfo)
    // if(! this.pdfData )this.pdfData = this.workflow.variables.processData
    this.leData = this.pdfData.leData;
    this.leData['dies'] = this.leData.projectedDeath
    this.livesArray = this.leData['lives']
    this.loop();
  }


  initData() {

    let dob;
    let gender;
    let pdfData;

    if(! this.leData) {
      dob = this.workflow.variables.processData.generalInfoValues.DOB;
      gender = this.workflow.variables.processData.generalInfoValues.Gender
      pdfData = this.workflow.variables.pdfData;
      this.leTablesData.lives = this.leData['lives']
      this.leTablesData.dies = this.leData['dies']
      console.log('leTablesData', this.leTablesData)
    } else {
      dob = this.generalInfo.DOB;
      gender = this.generalInfo.Gender
      pdfData = this.pdfData;
      this.leTablesData.lives = this.leData['lives']
      this.leTablesData.dies = this.leData['dies']

    }

    /*
Client Name       Q Capital                                  
Insured Name    Jhon Smith                                
Case ID             1000001BD  
Client Internal Case ID    ahgef126
Date Of Birth     MM/DD/YYYY
Age                    85.7
Gender               Male/Female
Smoker/Non-Smoker
Assessment Date– (Today) MM/DD/YYYY
Estimated Life Expectancy Mean (months) - 121
Estimated Life Expectancy Median (months) - 123

    */
    this.predictionData = [
      { header: 'Company Name', highlightValue: pdfData.genInfoData['company'] },
      { header: 'Case ID', highlightValue: pdfData.genInfoData['caseId'] },
      { header: 'Internal ID', highlightValue: '' },
      { header: 'Assessment Date', highlightValue: pdfData.genInfoData['assessmentDate'] },
      { header: 'Gender', highlightValue: pdfData.genInfoData['gender'] },
    ];

    this.medicalHistoryInfo = [
      { header: 'Insured\'s Name', highlightValue: pdfData.genInfoData['insuredName'] },
      { header: 'Date Of Birth', highlightValue:  pdfData.genInfoData['dob']},
      { header: 'Age', highlightValue: pdfData.genInfoData['age']},
      { header: 'Estimated LE Median (months)', highlightValue: pdfData.leData.median},
      { header: 'Estimated LE Mean (months)', highlightValue: pdfData.leData.average}
    ]
  }


  loop() {
    if(this.leData) {
      console.log('loop', this.pdfData, this.leData, this.livesArray)
      this.initData();
      this.initChart();
    }
    if (this.workflow.variables.processSteps.isPdfDone) {
      this.initData();
      this.initChart();
      // if (!this.workflow.variables.processData.pdfName) {
      //   setTimeout(() => {
      //     this.downloadPdf();
      //   }, 1500);
      // }
    } else {
      setTimeout(() => { this.loop(); }, 1 * 1000);
    }
  }


  initChart() {
    setTimeout(() => {
      echarts.init(this.chartLives.nativeElement, 'light', { renderer: 'svg' }).setOption(this.getOptionsForGraph('lives'));
      echarts.init(this.chartLives2.nativeElement, 'light', { renderer: 'svg' }).setOption(this.getOptionsForGraph2('lives'));
    }, 300);
  }


  getOptionsForGraph(type) {
    const xArray = this.leData['lives'].map((a, b) => b + 1);


    return {
      title: { text: 'Projected Survivorship' },
      xAxis: {
        type: 'category',
        data: xArray,
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          data: this.leData['lives'],
          type: 'line',
          showSymbol: false,
        },
      ],
    };
  }
  getOptionsForGraph2(type) {
    const xArray = this.leData['dies'].map((a, b) => b + 1);

    return {
      title: { text: 'Projected Percentage of Deaths Per Year' },
      xAxis: {
        type: 'category',
        data: xArray,
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          data: this.leData['dies'],
          type: 'line',
          showSymbol: false,
        },
      ],
    };
  }
  downloadPdf() {
    // this.loading = true;
    // this.router.navigateByUrl('/manage/investment-opportunities');
    // function getAllStyle(t) {
    //   var strStyle = "";

    //   for (let i = 0; i < t.length; i++) {
    //     for (let k = 0; k < t[i].length; k++) {
    //       strStyle += t[i][k].cssText + '\n';
    //     }
    //   }
    //   return strStyle;
    // }
    // function getAllRules() {
    //   const list = document.styleSheets;
    //   var array = []
    //   for (var i = 0; i < list.length; i++) {
    //     array.push(list[i]['cssRules'])
    //   }
    //   return array;
    // }
    function cssSpcElement(a) {
      var sheets = document.styleSheets, o = [];
      a.matches = a.matches || a.webkitMatchesSelector || a.mozMatchesSelector || a.msMatchesSelector || a.oMatchesSelector;
      for (var i in sheets) {
        var rules = sheets[i]['rules'] || sheets[i]['cssRules'];
        for (var r in rules) {
          if (a.matches(rules[r]['selectorText'])) {
            o.push(rules[r].cssText);
          }
        }
      }
      return o;
    }

    function recGetElements(el, arr) {
      arr.push(el);
      if (el.children.length) {
        for (let i = 0; i < el.children.length; i++) {
          recGetElements(el.children[i], arr);
        }
      }
    }

    function printAllStyle(t) {
      var strStyle = "";

      for (var i = 0; i < t.length; i++) {
        strStyle += t[i] + '\n';
      }
      return strStyle;
    }

    function collectAllStyles(elem) {
      let array = [];
      recGetElements(elem, array);
      let stylesArray = [];
      for (let index = 0; index < array.length; index++) {
        stylesArray = stylesArray.concat(cssSpcElement(array[index]));
      }
      stylesArray = stylesArray.filter((item, i, ar) => ar.indexOf(item) === i);
      var str = printAllStyle(stylesArray);
      return str;
    }

    let styleStr = '@font-face { font-family: "Varela Round"; src: url("https://list-crm.s3.us-east-2.amazonaws.com/assets/VarelaRound-Regular.ttf"); }' + '\n'
    styleStr += collectAllStyles(this.toPdf.nativeElement);
    // const styleStr = getAllStyle(getAllRules()).replace('./src/assets/fonts/Varela-Round/VarelaRound-Regular.tf', 'https://list-crm.s3.us-east-2.amazonaws.com/assets/VarelaRound-Regular.ttf')
    // .replace('url("VarelaRound-Regular.ttf','url("https://list-crm.s3.us-east-2.amazonaws.com/assets/VarelaRound-Regular.ttf' );

    var body = '<html><head><style>' + styleStr + '</style></head><body style="width: 210mm; padding-left: 15px;">' + this.toPdf.nativeElement.innerHTML  + '</body></html>'
    const data = {
      filename: `${this.workflow.variables.generalDataProcess.dirName}/${this.workflow.variables.generalDataProcess.dirName.split('_')[1]}.html`,
      content_type: 'text/html'
    }
    var vb = new Blob([body]);

    this.server.postFileToAws('getUrl', data, vb, 'myCss.html').subscribe(data => {
      if (!data['done']) {
        return
      } else {
        this.server.postWithToken('files/getPdf', data).subscribe((data: any) => {
          this.workflow.variables.processData.pdfPath = data.url
          this.workflow.updateUrl()
          this.pdfIsReady = true
        })
      }

    });
  }

  downloadReadyPdf() {
    if (!this.pdfData || ! this.pdfData.isPdfReady) {
      alert('Pdf is not ready yet, Please wait...')
      return
    }
    let path = { fileName: `${this.dirName}/${this.pdfData.pdfName}`}
    this.server.postWithToken('files/getPdf', path).subscribe((data: any) => {
      this.fileUrl = data.url
      this.fileName = 'report.pdf'
      setTimeout(() => {
        this.download.nativeElement.click();
      }, 100);
      // this.workflow.updateUrl()
      // this.pdfIsReady = true
    })
   
    // this.download.nativeElement.click();
    // document.getElementById('downloadPdf').click();

  }

}
const disclaimer = `<div style="width: 100%; height: 270mm; margin-top: 50px; text-align: justify">
<h2
    style='     width: 100%;
margin-top:3.0pt;margin-right:0cm;margin-bottom:3.0pt;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
    <u><span style="font-size:12px;color:black;">LiST&rsquo;s DISCLAIMERS&nbsp;</span></u></h2>
<h2
    style='margin-top:3.0pt;margin-right:0cm;margin-bottom:3.0pt;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'>
    <span style="font-size:12px;color:black;font-weight:normal;">&nbsp;</span></h2>
<p
    style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'>
    <span style="font-size:12px;color:black;">LiST Funding, Inc (&ldquo;LiST&rdquo;) provides data for life
        expectancy estimates by applying proprietary methods, systems and resources to written health and
        medical information provided by or on behalf its client to LiST. Life expectancy projections prepared by
        LiST are only estimates of estimated future mortality and are not guarantees of actual mortality
        results. LiST does not represent<strong>,</strong> warrant <strong>or guarantee&nbsp;</strong>to any
        client or other person that an insured will die on or near any projected mortality
        date<strong>&nbsp;prepared by LiST</strong>. Client acknowledges that there may be information that
        materially affects an estimated life expectancy of an insured that has not been provided to LiST and
        which could materially alter any life expectancy estimate provided by LiST to its client.
        LiST</span><span style="font-size:12px;">&nbsp;is&nbsp;</span><span style="font-size:12px;">not a
        licensed insurance advisor, agency, brokerage, consultant, counselor or producer; life settlement
        provider or broker; or registered investment advisor. If any medical data provided to LiST are illegible
        or otherwise of poor quality, LiST may be unable to incorporate such data into its <span
            style="color:black;">life expectancy estimate</span>, and if such information is incorporated into
        it its <span style="color:black;">life expectancy estimate,</span> such data may materially alter
        LiST&rsquo;s <span style="color:black;">life expectancy estimate</span>.<span
            style="color:black;">&nbsp;LiST</span> expressly disclaims and nothing contained herein is intended
        to be, and shall not be, construed or interpreted, to mean, that <span style="color:black;">LiST</span>
        is rendering any actuarial, estate planning, financial planning, insurance, investment, legal, tax or
        any other type of advice, counsel or opinion to any person. LiST does not transact business as a life
        expectancy provider or estimator in Florida or Texas. <span style="color:black;">LiST</span> does not
        create, accept or assume, and expressly disclaims creating, accepting or assuming, any fiduciary
        obligation or liability to Client, any life insurance policy owner, insured or beneficiary or purchaser
        of or investor in any life insurance policy. All estimated life expectancy reports prepared by <span
            style="color:black;">LiST</span> are subject to all the terms, conditions and limitations of
        liability contained in the <span style="color:black;">LiST&rsquo;s</span> Terms of Service for
        purchasing a LiST <span style="color:black;">life expectancy estimate</span>. Client acknowledges and
        agrees that any information contained in a <span style="color:black;">life expectancy estimate</span>
        provided to client by LiST shall not be used by client in any manner that violates any applicable law.
        This LiST estimated life expectancy reports was prepared using LiST&rsquo;s current methodology. From
        time‐to‐time, LiST may develop new methodologies or data analytics using methods that differ from its
        then current standard methodology, and new methodologies may include different or additional data,
        analysis, algorithms or technology than those used by LiST for this estimated life expectancy report and
        may result in different life expectancy estimate for the same individual, which may be materially
        different than this estimated life expectancy report for that same individual.</span></p>
<h1
    style='margin-top:24.0pt;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'>
    <span style="font-size:12px;font-weight:normal;">LiST&nbsp;</span><span
        style="font-size:12px;font-weight:normal;">PROVIDES ITS SERVICES TO CLIENT ONLY &quot;AS IS,&quot;
        &ldquo;WHERE IS,&rdquo; &ldquo;WITH ALL FAULTS,&rdquo; AND WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        IMPLIED. &nbsp; CLIENT&nbsp;</span><span style="font-size:12px;font-weight:normal;">UNDERSTANDS THAT
        LiST OBTAINS DATA INCLUDED IN THE SERVICES FROM THIRD PARTIES, THAT LiST MAKES NO WARRANTIES, WHETHER
        EXPRESS OR IMPLIED, OF ANY KIND REGARDING THE ACCURACY OR COMPLETENESS OF ANY SUCH DATA, AND THAT LiST
        IS UNDER NO OBLIGATION TO CORRECT ANY ERROR OR OMISSION THEREIN. LiST MAKES NO WARRANTIES, TERMS OR
        CONDITIONS OF ANY KIND, EXPRESS, IMPLIED OR STATUTORY, ABOUT LiST&rsquo;S SERVICES OR THE SUITABILITY,
        LEGALITY OR ACCURACY OF THE INFORMATION, OR SERVICES DESCRIBED OR CONTAINED ON LiST&rsquo;S WEBSITE.
        &nbsp;TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, LiST EXPRESSLY DISCLAIMS ALL IMPLIED
        WARRANTIES, TERMS OR CONDITIONS OF SATISFACTORY QUALITY, MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE, TITLE OR NON-INFRINGEMENT.&nbsp;</span><span style="font-size:12px;">LiST<span
            style="color:black;">&nbsp;LIFE EXPECTANCY REPORTS OBTAINED OR RECEIVED BY CLIENT FROM ANY SOURCE
            OTHER THAN DIRECTLY FROM&nbsp;</span>LiST<span style="color:black;">&nbsp;ARE EXPRESSLY DISCLAIMED
            BY&nbsp;</span>LiST<span style="color:black;">&nbsp;AND&nbsp;</span>LiST</span><span
        style="font-size:12px;color:black;">&nbsp;DOES NOT GUARANTEE THEIR AUTHENTICITY.</span></h1>
<p
    style='margin-top:0cm;margin-right:0cm;margin-bottom:12.0pt;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;'>
    <span style="font-size:12px;">&nbsp;</span></p>
<p
    style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'>
    <strong><span style='font-size:12px;font-family:"David",sans-serif;'>CONFIDENTIALITY
            NOTICE:&nbsp;</span></strong><span style='font-size:12px;font-family:"David",sans-serif;'>This
        document contains confidential information only for the use of intended recipient client of LiST. If you
        are not the intended recipient, you are hereby notified that any disclosure, copying, distribution,
        dissemination, or the taking of any action in reliance on the contents of its information is strictly
        prohibited.</span></p>
<p
    style='margin-top:0cm;margin-right:0cm;margin-bottom:12.0pt;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;'>
    <span style="font-size:12px;">&nbsp;</span></p>
</div>
`